import React, { useState, useRef, useCallback, useEffect } from 'react';
import firebase, { firestore, functions } from '../firebase/firebase';
import {
  useParams,
  useHistory,
} from 'react-router-dom';
import { Typography, Tabs, Tab, Grid, Button } from '@material-ui/core';
import ApplicationIdentityDocuments from './ApplicationIdentityDocuments';
import ApplicationPersonalInfo from './ApplicationPersonalInfo';
import ApplicationSupportingDocuments from './ApplicationSupportingDocuments';
import ApplicationDecision from './ApplicationDecision';
import ApplicationDecisions from './ApplicationDecisions';
import { statusCodes } from '../utilities/constants';
import { saveSubmission } from '../firebase/saveSubmission';
import queryLegacyMember from '../firebase/queryLegacyMember';
const personnummer = require('personnummer.js');

function MemberApplication({ user, setUser, localUser, setLocalUser, storeGroups }) {

  const isMounted = useRef(false);

  const [submissionIsEditable, setSubmissionIsEditable] = useState(false);
  const [usersWithSamePersonalId, setUsersWithSamePersonalId] = useState(null);
  const [legacyMember, setLegacyMember] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    isMounted.current = true;


    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    // console.log("memberCategory: ", localUser.submission.memberCategory);
    // console.log(localUser.submission);
  }, [localUser]);

  // Submission personal ID was changed.
  useEffect(() => {
    // console.log("personal id updated");
    if (!personnummer.validate(localUser?.submission?.personalId)) {
      setUsersWithSamePersonalId([]);
      return;
    }
    const queryDuplicates = async () => {
      let queryRef = firestore.collection('users')
        .where("personalId", "==", personnummer.normalise(localUser?.submission?.personalId))
        .where(firebase.firestore.FieldPath.documentId(), "!=", localUser?.id);
      const otherUserDocs = [];
      try {
        const querySnapshot = await queryRef.get();
        querySnapshot.forEach((userDoc) => {
          otherUserDocs.push({
            id: userDoc.id,
            reset: false,
            ...userDoc.data(),
          });
        });
      } catch (error) {
        console.error("Could not check personal ID. ", error);
      }
      isMounted.current && setUsersWithSamePersonalId(otherUserDocs);
    };
    queryDuplicates();

    const handleQueryLegacyMember = async () => {
      const legacyMember = await queryLegacyMember(localUser?.submission?.personalId);
      if (legacyMember !== null) {
        isMounted.current && setLegacyMember(legacyMember);
      }
    };
    handleQueryLegacyMember();

  }, [localUser?.submission?.personalId]);


  const handleSubmissionChange = (submission) => {
    setLocalUser({
      ...localUser,
      submission,
    });
  };

  

  // Local submission newDecision.
  useEffect(() => {
    if (localUser?.submission?.newDecision !== true) { return; }

    const statusCode = localUser?.submission?.statusCode;
    if (!statusCode) { return; }

    setIsSaving(true);
    // const userRef = firestore.doc(`users/${user?.id}`);
    // const timestamp = firebase.firestore.FieldValue.serverTimestamp();
    // const now = Date.now();
    // const key = `decisions.${now}`;
    let _submission = { ...localUser.submission };
    // delete _submission.newDecision; // newDecision is just a local flag. Don't send to DB.
    // _submission[key] = {
    //   id: now,
    //   statusCode,
    //   timestamp,
    //   "feedbackFromAdmin": "",
    // };

    // Submission was rejected.
    if (statusCode === statusCodes[400]) {

    }

    // Submission has unresolved issues.
    if (statusCode === statusCodes[500]) {

      // if (!_submission.approveIdentity) {
      //   _submission.identityDocumentURL = null;
      //   _submission.selfieURL = null;
      // }

      // if (!_submission.approvePersonalInfo) {
      //   _submission.firstName = "";
      //   _submission.lastName = "";
      //   _submission.personalId = "";
      // }

    }

    // Submission was approved.
    if (statusCode === statusCodes[600]) {

    }



    const handleSaveSubmission = async () => {
      // try {
      //   await userRef.update({
      //     submission: _submission,
      //   });
      // } catch (error) {
      //   console.error("Could not update submission. ", error);
      // }
      const result = await saveSubmission({
        user: localUser,
        storeGroups,
      });
      // console.log(result);
      if (isMounted.current) {
        setLocalUser(localUser => ({
          ...localUser,
          submission: {
            ..._submission,
            feedbackFromAdmin: "",
            newDecision: false,
          }
        }));

        // if ((statusCode === statusCodes[500] || statusCode === statusCodes[600]) && _submission.approveIdentity && _submission.approvePersonalInfo) {
        //   try {
        //     await userRef.update({
        //       firstName: _submission.firstName,
        //       lastName: _submission.lastName,
        //       personalId: _submission.personalId,
        //     });
        //   } catch (error) {
        //     console.error("Could not update submission. ", error);
        //   }
        // }
        setIsSaving(false);
      }
    }
    handleSaveSubmission();


  }, [localUser?.submission?.newDecision]);

  useEffect(() => {
    const code = user?.submission?.statusCode?.code;
    setSubmissionIsEditable(
      code === statusCodes[100].code ||
      code === statusCodes[200].code ||
      code === statusCodes[300].code
    );
  }, [user?.submission?.statusCode]);

  const sortedDecisions = useCallback(() => {
    const decisions = user?.submission?.decisions;
    if (!decisions) {
      return null;
    }
    const sorted = Object.entries(decisions).sort((a, b) => {
      const aDate = a[1].timestamp.toDate();
      const bDate = b[1].timestamp.toDate();
      if (aDate < bDate) { return -1; }
      else if (aDate > bDate) { return 1; }
      return 0;
    });
    return sorted.map(decision => (
      decision[1]
    ));
  }, [user?.submission?.decisions]);

  if (typeof user?.submission === 'undefined' || user?.submission === null) { return null; }

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography style={{ textAlign: 'left', marginTop: 20 }}>{`Status: ${user?.submission?.statusCode?.label}`}</Typography>
        </Grid>
        <Grid item xs={12}>
          <ApplicationDecisions
            previousDecisions={sortedDecisions()}
          />
        </Grid>
        {
          !submissionIsEditable &&
          <Grid item xs={12}>
            <Button
              onClick={() => {
                setSubmissionIsEditable(true);
              }}
              variant='outlined'
              color='primary'
            >Öppna ärende</Button>
          </Grid>
        }
        {
          submissionIsEditable &&
          <>
            <Grid item xs={12}>
              <ApplicationIdentityDocuments
                identityDocumentURL={user?.submission?.identityDocumentURL}
                selfieURL={user?.submission?.selfieURL}
                submission={localUser?.submission}
                onChange={handleSubmissionChange}
              />
            </Grid>
            <Grid item xs={12}>
              <ApplicationPersonalInfo
                type='membership-application'
                submission={localUser?.submission}
                storeGroups={storeGroups}
                onChange={handleSubmissionChange}
                usersWithSamePersonalId={usersWithSamePersonalId}
                setUsersWithSamePersonalId={setUsersWithSamePersonalId}
                approvalToggle={true}
              />
            </Grid>
            <Grid item xs={12}>
              <ApplicationSupportingDocuments
                supportingDocuments={user?.submission?.supportingDocuments}
                submission={localUser?.submission}
                onChange={handleSubmissionChange}
              />
            </Grid>
            <Grid item xs={12}>
              <ApplicationDecision
                submission={localUser?.submission}
                usersWithSamePersonalId={usersWithSamePersonalId}
                // previousDecisions={user?.submission?.decisions}
                onChange={handleSubmissionChange}
                isSaving={isSaving}
              />
            </Grid>
          </>
        }
      </Grid>
    </React.Fragment>
  );

}

export default MemberApplication;